// External
import React from "react";
import { useI18n } from "Hooks";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";

// Design System
import { Tooltip } from "@toddle-edu/ds-web";

// Styles
import classes from "./InlineMoreItemsWithTooltip.scss";

// Utils
import { onEnterOrSpaceKeyDown } from "Utils";

const InlineMoreItemsWithTooltip = props => {
  const {
    items,
    length,
    noItemText,
    moreJoinSymbol,
    customClass,
    moreItemCustomClass,
    toolTipItemTextClass,
    tooltipOverlayStyle,
    trigger,
  } = props;

  const { t } = useI18n();

  if (_.isEmpty(items)) {
    return <span className={"text-body text-disabled"}>{noItemText}</span>;
  }

  const visibleItems = _.slice(items, 0, length);
  const remainingItemsCount = _.size(items) - length;

  const tooltipContent = (
    <div>
      {_.map(items, (item, index) => (
        <div className={toolTipItemTextClass} key={index}>
          {item}
        </div>
      ))}
    </div>
  );

  const moreItemsTextClasses = classNames(
    classes.textColorInfo,
    classes.moreItemsText,
    moreItemCustomClass
  );

  const handleClick = e => {
    e.stopPropagation();
  };

  const handleKeyDown = e => {
    onEnterOrSpaceKeyDown(e, handleClick);
  };

  return (
    <span className={classes.container}>
      {_.map(visibleItems, (item, index) => (
        <span key={index} className={customClass} dir="auto">
          {item}
          {index < _.size(visibleItems) - 1 ? ", " : ""}
        </span>
      ))}
      {remainingItemsCount > 0 ? (
        <Tooltip
          tooltip={tooltipContent}
          trigger={trigger}
          placement={"right"}
          showArrow
          overlayStyle={tooltipOverlayStyle}
        >
          <span
            className={moreItemsTextClasses}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
          >
            {t("common:number_more", {
              number: `${moreJoinSymbol}${remainingItemsCount}`,
            })}
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
};

InlineMoreItemsWithTooltip.defaultProps = {
  items: [],
  length: 0,
  noItemText: "",
  moreJoinSymbol: " +",
  customClass: "text-body",
  moreItemCustomClass: "",
  trigger: ["focus", "click"],
};

InlineMoreItemsWithTooltip.propTypes = {
  items: PropTypes.array,
  length: PropTypes.number,
  noItemText: PropTypes.string,
  moreJoinSymbol: PropTypes.string,
  customClass: PropTypes.string,
  moreItemCustomClass: PropTypes.string,
  tooltipOverlayStyle: PropTypes.object,
};

export default InlineMoreItemsWithTooltip;
